export const environment = {
  production: false,
  version: 1,
  api: {
    base: "https://apim-np-t-idb-integration.iadb.org/operations/luca/api/v1/",
    baseUpload: "https://apim-np-t-idb-integration.iadb.org/operations/luca-ezshare/api/v1/",
    history: "efas/History",
    id : "1b774fbe-2def-4b51-94ee-97a7592caaab",
    subscriptionHeader: "Ocp-Apim-Subscription-Key",
    subscriptionKey: "711dcb05efc342d5960674fe323c5405",
    scope: 'api://1b774fbe-2def-4b51-94ee-97a7592caaab/api-access',
  },
  auth: {
    tenant: "9dfb1a05-5f1d-449a-8960-62abcb479e7d",
    clientId: "58a9e5b5-18c5-4658-8d87-008e235fc882",
    authority:
      "https://login.microsoftonline.com/9dfb1a05-5f1d-449a-8960-62abcb479e7d",
    redirectUri: "https://luca2-test.iadb.org/",
    postLogoutRedirectUri: "https://luca2-test.iadb.org/",
    endpoints: {
      "https://luca2-test.iadb.org/":
      "f0031bdd-341e-456f-9d3e-ecb997d05556",
   },
  },
  dashboard: {
    kpi: 'https://app.powerbi.com/reportEmbed?reportId=24193532-d605-4a3d-ae32-18373676b0fd&autoAuth=true&ctid=9dfb1a05-5f1d-449a-8960-62abcb479e7d'
  },
  instrumentationKey: '8fbc036b-fc2c-4ff7-92f5-647d3c8eae23'
}; 
